import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PtaSousActivite } from 'src/app/shared/models/ptasousactivite';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-decaissemnt',
  templateUrl: './decaissemnt.component.html',
  styleUrl: './decaissemnt.component.scss'
})

export class DecaissemntComponent {


  submitted: boolean = false;

  actionData: any = [];
  modalRef: NgbModalRef | null = null;
  item: any = {};
  itemToDelete!: any;
  @ViewChild('decaisemmentModal') modalContent: TemplateRef<any>;
  items: PtaSousActivite[] = [];
  itemDecaissement: any;
  projetId: any;
  isLoading: boolean = false;
  selectedDirection: any ;


  paginatedItems: PtaSousActivite[] = [];

  firstEncaissement = 0;
  rowsEncaissemnt = 10;
  paginatedEncaissement: PtaSousActivite[] = [];
  totalRecords: number = 0; // Nombre total d'éléments
  itemsListCopy: any[] = [];

  firstDecaissement = 0;
  rowsDecaissement = 10;
  paginateDecaissment = [];
  totalRecords2: number = 0; // Nombre total d'éléments
  showFiltre: boolean = false;
  directionItems: any = [];
  userInfo: any;

  ExerciceItems: any = [];
  projetItems: any = [];
  annee: any;
  selectedProjet: any;
  directionId: any;
  sousActiviteItem: PtaSousActivite = new PtaSousActivite();
  isLoadingDecaissement: boolean = false;
  @ViewChild('decaissementtModalDetail') modalContent1!: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxservice: NgxUiLoaderService
  ) { }

  ngOnInit(): void {

    this.projetId = this.localstorage.getProjetToUser();
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    this.userInfo = this.localstorage.getInfoUserToService();

    if (this.userInfo?.data?.groupe === "admin") {
      this.showFiltre = true;
      this.getDirection();
      this.getProjetsList();
    }
    if (this.userInfo?.data?.groupe === "point_focal") {

      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;

      this.getProjetByDirection(this.directionId);
    }
    if (this.userInfo?.data?.groupe !== "admin" && this.userInfo?.data?.groupe !== "point_focal") {
      this.getProjetsList();
    }
    this.getTacheDecaissemnt();
    this.calculateReste();
  }//end


  getProjetsList() {
    this.paramservice.getListUserProjects(this.userInfo?.data?.reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
        ////console.log(this.projetItems);
      },
      (error) => {
      }
    )
  }//end getProjetsList

  getDirectionByProjet(reference: any) {
    this.paramservice.getDirectionsByProjet(reference).subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error: any) => {
      }
    )
  }//end getProjetByDirection

  processSelectedProjet() {
    //get sous activites associated
    this.getTacheDecaissemnt();

    //get direction associated
    if (this.selectedProjet) {
      this.getDirectionByProjet(this.selectedProjet);
    }
  }
  getEncaissement(item: any) {
    this.isLoading = true;
    this.ngxservice.start();
    this.paramservice.getEncaissement(item).subscribe(
      (response: any) => {
        this.items = response.data;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.ngxservice.stop();
        this.isLoading = false;
        this.updatePaginatedEncaissement();
      },
      (error) => {
        this.ngxservice.stop();
        //   this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "une erreur est survenu lors de la recuperation de la liste des ordonnancements", life: 3000 });
      }
    );
  }

  getDecaissement(item: any) {
    this.isLoading = true;

    this.paramservice.getDecaissement(item).subscribe(

      (response: any) => {
        this.ngxservice.stop()

        this.isLoading = false;
        this.itemDecaissement = response.data;
        this.totalRecords2 = this.itemDecaissement.length
        this.updatePaginatedDecaissement()
      },
      (error) => {
        this.ngxservice.stop()
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "une erreur est survenu lors de la recuperation de la liste des décaissement", life: 3000 });
      }
    );
  }



  openModal(sousActivite: PtaSousActivite) {
    //console.log("sousActivite",sousActivite);

    if (sousActivite instanceof PtaSousActivite) {
      this.sousActiviteItem = sousActivite;
    } else {
      this.sousActiviteItem = Object.assign(new PtaSousActivite(), sousActivite);
    }

    this.calculateReste();
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }//end openModal


  fileName: any;

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.sousActiviteItem.fichier = file;

    }
  }
  //enregistrement saveEncaissement
  saveEncaissement() {

    if (!this.sousActiviteItem.canEncaissement()) {
      this.messageService.add({ severity: 'info', summary: 'X-Project', detail: this.sousActiviteItem.getErrorMessage() });
      return;
    }

    // if (this.sousActiviteItem.total_engage < (this.sousActiviteItem.total_ordonnance + this.sousActiviteItem.total_a_ordonnancer)) {
    //   this.messageService.add({ severity: 'info', summary: 'X-Project', detail: "Le montant ordonnancé ne peut pas dépasser le montant engagé." });
    //   return;
    // }
    else {

    const formData = new FormData();

      formData.append('total_decaisse', this.sousActiviteItem.total_decaisse)
      formData.append('total_ordonnance', this.sousActiviteItem.total_ordonnance)
      formData.append('date_decaissement', this.sousActiviteItem.date_decaissement)
      formData.append('total_a_decaisser', this.sousActiviteItem.total_a_decaisser)
      formData.append('total_engage', this.sousActiviteItem.total_engage)
      formData.append('reference', this.sousActiviteItem.reference)
      formData.append('no_fichier', this.sousActiviteItem.no_fichier)
      formData.append('observations', this.sousActiviteItem.observations)

      if (this.sousActiviteItem.fichier) {
        formData.append('fichier', this.sousActiviteItem.fichier)
      }

      this.ngxservice.start();
      this.paramservice.saveDecaissement(formData).subscribe(
        (response: any) => {

          this.messageService.add({ severity: 'success', summary: 'X-Project', detail: response.message });
          this.ngxservice.stop();
          this.getTacheDecaissemnt()
          this.modalService.dismissAll();
        },
        (error:any) => {
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: 'X-Project', detail: error.error.message || "une erreur est survenu lors de l'enregistrement de l'encaissement", life: 3000 });
          this.ngxservice.stop();
        }
      )
    }
  }//end saveOrdonnancement


  //calcul reste
calculateReste() {
  console.log('ordonnance:', this.sousActiviteItem.total_ordonnance);
  console.log('a decaisser:', this.sousActiviteItem.total_decaisse);

  this.sousActiviteItem.reste =
    this.sousActiviteItem.total_ordonnance - this.sousActiviteItem.total_decaisse;
}  
  
  //end calculateReste


  
  updatePaginatedEncaissement() {
    const start = this.firstEncaissement;
    const end = start + this.rowsEncaissemnt;
    this.paginatedEncaissement = this.items.slice(start, end);
  }

  // Méthode pour mettre à jour les données paginées des activités
  updatePaginatedDecaissement() {
    const start = this.firstDecaissement;
    const end = start + this.rowsDecaissement;
    this.paginateDecaissment = this.itemDecaissement.slice(start, end);
  }


  onPageEncaissement(event: any) {
    this.firstEncaissement = event.first
    this.rowsEncaissemnt = event.rows
    this.updatePaginatedEncaissement();
  }

  onPageChangeDecaissemnt(event: any) {
    this.firstDecaissement = event.first
    this.rowsDecaissement = event.rows
    this.updatePaginatedDecaissement();
  }


  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error) => {
      }
    )
  }

  getProjetByDirection(reference: any) {
    this.paramservice.getProjetByDirection(reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
      },
      (error: any) => {
      }
    )
  }

  getTacheDecaissemnt() {
    this.ngxservice.start()
    const request = {
      user_ref: this.userInfo?.data?.reference,
      programme_id: this.selectedProjet || null,
      annee: this.annee,
      direction_id: this.selectedDirection || this.directionId || null

    };

    this.getEncaissement(request);
    this.getDecaissement(request);
  }

  filterDataByDirections() {
    this.getTacheDecaissemnt();
  }//en filterDataByDirections


  //annuler cancelEncaissement
  cancelEncaissement(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir annuler cet encaissement',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxservice.start();
        this.paramservice.annulationEncaissement(event.reference).subscribe(
          (response: any) => {
            this.ngxservice.stop();
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: 'Décaissement a été annulé' });
            this.getTacheDecaissemnt();
            this.loadOrdonnancements(this.activiteIdd);
          },
          (error:any) => {
            this.ngxservice.stop();
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.message || "une erreur est survenu", life: 3000 });
          },
        )
      },
    });
  }//end cancelEncaissement


  isLoadingOrdonnancement: boolean = false

 exportToDocument(item: any) {

    if (!item) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attention',
        detail: 'Aucun élément sélectionné'
      });
      return;
    }


    this.ngxservice.start();

    this.paramservice.downloadFicheDecaissement(item.reference).subscribe(
      (response: Blob) => {

        //  définir extension dynamique
        const extension = 'pdf';
        const filename = `decaissement.${extension}`;

        // téléchargement
        FileSaver.saveAs(response, filename);

        // ouverture auto seulement pour PDF
        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxservice.stop();

        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: `Fichier ${extension.toUpperCase()} téléchargé`,
          life: 3000
        });

      },
      (error) => {
        this.ngxservice.stop();

        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Téléchargement échoué',
        });
      }
    );
  }



  activiteIdd:any

  openModalHistoriqueDecaissement(item: any) {

    this.modalService.open(this.modalContent1, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });

    this.activiteIdd  =  item.id;
    this.loadOrdonnancements(item.id);
  }//end openModal

  historicDecaissement: any = [];
  loadOrdonnancements(decaissement_ref: any) {
    this.isLoadingDecaissement = true;

    this.paramservice.getHistoriqueDecaissment(decaissement_ref).subscribe(
      (res: any) => {
        this.historicDecaissement = res.data || [];
        this.isLoadingDecaissement = false;
      },
      (error) => {
        this.isLoadingDecaissement = false;
        this.historicDecaissement = [];
      }
    );
  }

}
